import { defineMessages } from "react-intl";

export const myTeamMessages = defineMessages({
  "my-team.heading": {
    id: "my-team.heading",
    defaultMessage: "My Team",
  },
});
